const PRODUCTION_ENVIRONMENT_NAME = 'production';

// The preview is a work in progress: visible on every non-production build (local dev and staging)
// so it can be exercised, hidden in production until the inspection PDF replaces the existing print.
export function isInspectionPdfPreviewEnabled(environmentName: string): boolean {
  return environmentName !== PRODUCTION_ENVIRONMENT_NAME;
}
